import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

import SuccessHandler from '../SuccessHandler'

/* private BrandConfigurationCI Types */
import {
  Settings,
  _BrandConfigurationCI
} from '../namespace-helper'

import _ from 'lodash'

const selectedBrandConfigurationCITemplate = {
  id: null,
  name: 'New Brand CI',
  primary_color: '',
  secondary_color: '',
  main_logo_documents_id: null
}

export default {
  namespaced: true,
  state: {
    brandConfigurationCIs: [],
    allBrandConfigurationCIs: [],
    selectedBrandConfigurationCI: _.cloneDeep(selectedBrandConfigurationCITemplate),
    openDialog: false,
    defaultCI: {
      brand_configurations_ci: {
        main_logo: null
      }
    }
  },
  mutations: {
    [_BrandConfigurationCI.mutations.setBrandConfigurationCIs] (state, payload) {
      state.brandConfigurationCIs = payload
    },
    [_BrandConfigurationCI.mutations.setAllBrandConfigurationCIs] (state, payload) {
      state.allBrandConfigurationCIs = payload
    },
    [_BrandConfigurationCI.mutations.setSelectedBrandConfigurationCI] (state, payload) {
      if (payload !== null) {
        state.selectedBrandConfigurationCI = payload
      } else {
        state.selectedBrandConfigurationCI = _.cloneDeep(selectedBrandConfigurationCITemplate)
      }
    },
    [_BrandConfigurationCI.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_BrandConfigurationCI.mutations.addNewCI] (state, payload) {
      if (state.brandConfigurationCIs === null) {
        state.brandConfigurationCIs = []
      }
      state.brandConfigurationCIs.push(payload)
    },
    [_BrandConfigurationCI.mutations.removeCI] (state, payload) {
      state.brandConfigurationCIs.splice(payload, 1)
    },
    [_BrandConfigurationCI.mutations.setDefaultCI] (state, payload) {
      state.defaultCI = payload
    }
  },
  actions: {
    [_BrandConfigurationCI.actions.saveBrandConfigurationCI] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === null) {
          var url = API_URL + '/api/v1/brandConfigurationCIs'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/brandConfigurationCIs/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_BrandConfigurationCI.actions.loadBrandConfigurationCIs] (context, payload) {
      console.log('loadBrandConfigurationCIs: ' + JSON.stringify(payload))
      /* console.log('loadBrandConfigurationCIs: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/brandConfigurationCIs?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;name:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending
*/

      var url = API_URL + '/api/v1/brandConfigurationCIs'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationCI.mutations.setBrandConfigurationCIs, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationCI.actions.loadAllBrandConfigurationCIs] (context, payload) {
      var url = API_URL + '/api/v1/brandConfigurationCIs'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationCI.mutations.setAllBrandConfigurationCIs, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationCI.actions.removeCI] (context, payload) {
      const tempCI = context.getters.brandConfigurationCIs
      const id = tempCI[payload].id

      if (id === null) {
        context.commit(_BrandConfigurationCI.mutations.removeCI, payload)
        return
      }

      var url = API_URL + '/api/v1/brandConfigurationCIs/' + id

      console.log('removeCI: ' + id)

      store.commit(Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationCI.mutations.removeCI, payload)
        SuccessHandler.handleApiSuccess(store, r.data.message)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationCI.actions.openCloseDialog] ({ commit }) {
      commit(_BrandConfigurationCI.mutations.setOpenCloseDialogState)
    },
    [_BrandConfigurationCI.actions.setSelectedBrandConfigurationCI] ({ commit }, payload) {
      commit(_BrandConfigurationCI.mutations.setSelectedBrandConfigurationCI, payload)
    },
    [_BrandConfigurationCI.actions.addNewCI] ({ commit }, payload) {
      commit(_BrandConfigurationCI.mutations.addNewCI, payload)
    },
    [_BrandConfigurationCI.actions.resetState] ({ commit }, payload) {
      commit(_BrandConfigurationCI.mutations.setBrandConfigurationCIs, [])
      commit(_BrandConfigurationCI.mutations.setAllBrandConfigurationCIs, [])
      commit(_BrandConfigurationCI.mutations.setSelectedBrandConfigurationCI, null)
    }
  },
  getters: {
    [_BrandConfigurationCI.getters.brandConfigurationCIs] (state) {
      return state.brandConfigurationCIs
    },
    [_BrandConfigurationCI.getters.getAllBrandConfigurationCIs] (state) {
      return state.allBrandConfigurationCIs
    },
    [_BrandConfigurationCI.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_BrandConfigurationCI.getters.getSelectedBrandConfigurationCI] (state) {
      return state.selectedBrandConfigurationCI
    },
    [_BrandConfigurationCI.getters.defaultCI] (state) {
      return state.defaultCI
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/BrandConfiguration/brandConfigurationsCI.js